import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateEventDeliveryAddressMutationVariables = Types.Exact<{
  event_id: Types.Scalars['ID'];
  input: Types.CreateEventDeliveryAddressInput;
}>;


export type CreateEventDeliveryAddressMutation = { __typename?: 'Mutation', createEventDeliveryAddress: { __typename?: 'EventDeliveryAddress', id: string, name?: string | null, event_id?: string | null, is_event_default: boolean, linked_item_location_count: number } };


export const CreateEventDeliveryAddressDocument = gql`
    mutation CreateEventDeliveryAddress($event_id: ID!, $input: CreateEventDeliveryAddressInput!) {
  createEventDeliveryAddress(event_id: $event_id, input: $input) {
    id
    name
    event_id
    is_event_default
    linked_item_location_count
  }
}
    `;
export type CreateEventDeliveryAddressMutationFn = Apollo.MutationFunction<CreateEventDeliveryAddressMutation, CreateEventDeliveryAddressMutationVariables>;

/**
 * __useCreateEventDeliveryAddressMutation__
 *
 * To run a mutation, you first call `useCreateEventDeliveryAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventDeliveryAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventDeliveryAddressMutation, { data, loading, error }] = useCreateEventDeliveryAddressMutation({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEventDeliveryAddressMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventDeliveryAddressMutation, CreateEventDeliveryAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventDeliveryAddressMutation, CreateEventDeliveryAddressMutationVariables>(CreateEventDeliveryAddressDocument, options);
      }
export type CreateEventDeliveryAddressMutationHookResult = ReturnType<typeof useCreateEventDeliveryAddressMutation>;
export type CreateEventDeliveryAddressMutationResult = Apollo.MutationResult<CreateEventDeliveryAddressMutation>;
export type CreateEventDeliveryAddressMutationOptions = Apollo.BaseMutationOptions<CreateEventDeliveryAddressMutation, CreateEventDeliveryAddressMutationVariables>;